/**
 * Converts a numerical value into a shorthand string format using "M" for millions and "K" for thousands.
 * If the number is less than 1,000, it returns the number as a string with no shorthand.
 *
 * @example
 * console.log(formatNumber(1230000)); // Outputs: "1.23M"
 * console.log(formatNumber(1230));    // Outputs: "1.23K"
 * console.log(formatNumber(123));     // Outputs: "123"
 * console.log(formatNumber(10.00));   // Outputs: "10"
 */
export function formatNumber(num: number, precision = 2): string {
  if (num >= 1_000_000) {
    return parseFloat((num / 1_000_000).toFixed(precision)) + 'M';
  } else if (num >= 1000) {
    return parseFloat((num / 1000).toFixed(precision)) + 'K';
  } else {
    return parseFloat(num.toFixed(precision)).toString();
  }
}
